
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/financial-plan",
      function () {
        return require("private-next-pages/financial-plan.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/financial-plan"])
      });
    }
  